import React, {Component}  from 'react';
import {
  Row,
  Col,
  FormGroup,
  ControlLabel,
  Button
}                           from 'react-bootstrap';
import Select               from 'react-select';
import                           'react-select/dist/react-select.css';

class Filter extends Component {
  render() {
    let {
      filterUser,
      isSaving,
      checkboxes,
      stateSetter,
      loadOptions,
      save,
      accessible
    } = this.props;

    var btnIcnStyle = {
      color: 'white',
      marginRight: '5px',
      display: isSaving
        ? 'inline-block'
        : 'none'
    };

    const renderButton = () => checkboxes.length == 0 ?
      <div>
        <Button
          disabled
          className="btn-primary"
          style={{
            marginTop: '25px',
            display: accessible('UPDATE')
          }}
          >
          <i style={btnIcnStyle} className="fa fa-spinner fa-spin"></i>
          SAVE
        </Button>
      </div> :
      <div>
        <Button
          className="btn-primary"
          style={{
            marginTop: '25px',
            display: accessible('UPDATE')
          }}
          onClick={() => (accessible('UPDATE') === '') ? save() : {}}
          >
          <i style={btnIcnStyle} className="fa fa-spinner fa-spin"></i>
          SAVE
        </Button>
      </div> ;
    return (
      <Row>
        <Col md={3}>
          <FormGroup>
            <ControlLabel>Select User</ControlLabel>
            <Select.Async
              autoload={false}
              noResultsText="No Record Found"
              value={filterUser}
              onChange={(value) => stateSetter([{state: 'filterUser', value: value}])}
              loadOptions={loadOptions}
              />
          </FormGroup>
        </Col>
        <Col md={2}>
          {renderButton()}
        </Col>
      </Row>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./components/AccessRight/Filter.js